package rendering

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import com.github.joao_fernandes_fra.pzzle.generated.resources.BlackHanSans_Regular
import com.github.joao_fernandes_fra.pzzle.generated.resources.Res
import com.github.joao_fernandes_fra.pzzle.generated.resources.ShareTechMono_Regular
import org.jetbrains.compose.resources.Font

@Composable
fun fontMono(): FontFamily = FontFamily(Font(Res.font.ShareTechMono_Regular))

@Composable
fun fontTitle(): FontFamily = FontFamily(Font(Res.font.BlackHanSans_Regular))
